import { render, staticRenderFns } from "./MediaPublicId.vue?vue&type=template&id=29b04f46&"
import script from "./MediaPublicId.vue?vue&type=script&lang=ts&"
export * from "./MediaPublicId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports